import EtfTable from './EtfTable';

export default EtfTable;
